import { useQuery } from '@tanstack/react-query'
import React, { useContext, useEffect, useState } from 'react'
import { Check } from 'lucide-react'
import { toast } from 'react-toastify'
import { FiArrowDown, FiArrowRight } from 'react-icons/fi'
import { useParams, useHistory } from 'react-router-dom'
import { api, authHeaders } from '../../../services/api'
import Spinner from '../../../components/Spinner'
import Card from '../../../components/Card'
import masks from '../../../util/masks'
import Modal from '../../../components/Modal'
import { GlobalContext } from '../../../contexts/GlobalContext'
import { ModalPaymentContainer } from './styles'
import { addYears, format } from 'date-fns'

const emailUsuarioTeste = 'test_user_1878552748@testuser.com'

export default function () {
	const { user } = useContext(GlobalContext)

	const { plano_atual, plano_sugerido } = useParams()

	const history = useHistory()

	const [planoContratacao, setPlanoContratacao] = useState(null)

	const { data: planoAtual } = useQuery({
		queryKey: ['obter-plano-atual'],
		queryFn: async () => {
			const response = await api.get(`plano/${plano_atual}`)

			return response
		}
	})

	const { data: planoSugerido } = useQuery({
		queryKey: ['obter-plano-sugerido'],
		queryFn: async () => {
			const response = await api.get(`plano/${plano_sugerido}`)

			return response
		}
	})

	async function loadBricks() {
		const mp = new window.MercadoPago(process.env.REACT_APP_MERCADO_PAGO_KEY, {
			locale: 'pt-BR'
		})

		const bricksBuilder = mp.bricks()

		const email = process.env.REACT_APP_ENVIRONMENT === 'development' ?
			emailUsuarioTeste :
			user.pessoa.contato.find(c => c.tipo_contato_id === 6)?.contato

		const renderCardPaymentBrick = async bricksBuilder => {
			const settings = {
				initialization: {
					amount: planoContratacao.valor / 100,
					payer: {
						email
					}
				},
				customization: {
					visual: {
						style: {
							theme: 'default'
						},
						texts: {
							formTitle: 'Cartão de crédito',
							formSubmit: 'Confirmar mudança de plano'
						}
					},
					paymentMethods: {
						maxInstallments: 1,
						types: {
							excluded: ['debit_card']
						}
					}
				},
				callbacks: {
					onReady: () => { },
					onSubmit: async cardFormData => {
						try {
							await api.put(`plano/upgrade`, {
								token: cardFormData.token,
								plano_atual_id: planoAtual.id,
								plano_confirmado_id: planoContratacao.id
							}, authHeaders())

							toast.success('Sua assinatura foi atualizada com sucesso!')

							history.push('/dashboard')
						} catch (e) {
							toast.error(e.msg)
						}
					},
					onError: e => {
						toast.error(e.message)
					}
				}
			}

			window.cardPaymentBrickController = await bricksBuilder.create('cardPayment', 'cardPaymentBrick_container', settings)
		}

		renderCardPaymentBrick(bricksBuilder)
	}

	useEffect(() => {
		if (planoContratacao) {
			loadBricks()
		}

		return () => {
			window.cardPaymentBrickController?.unmount()
		}
	}, [planoContratacao])

	if (!planoAtual || !planoSugerido) {
		return <Spinner />
	}

	const diferencaValorPlanos = planoSugerido.valor - planoAtual.valor

	const mudancaDePeriodo = planoSugerido.periodo !== planoAtual.periodo

	return (
		<>
			<div className="flex flex-col text-slate-800 sm:mx-4 sm:my-6 mb-12 md:my-12 min-h-[46vh] leading-loose">
				<Card className="flex flex-col gap-4">
					<p className="mx-2">Após analisar seu perfil, gostaríamos de oferecer um plano com maiores vantagens para você.</p>

					<div className="flex flex-col md:grid md:grid-cols-[auto_1.6rem_auto] gap-6 md:items-start">
						<div className="flex flex-col gap-2">
							<h2 className="font-semibold text-slate-600 mx-2" style={{ fontSize: 16 }}>Seu plano atual</h2>

							<Plano
								plano={planoAtual}
							/>
						</div>

						<FiArrowRight size={20} className="justify-self-center self-center hidden md:block" />
						<FiArrowDown size={20} className="justify-self-center self-center md:hidden" />

						<div className="flex flex-col gap-2">
							<h2 className="font-semibold text-slate-600 mx-2" style={{ fontSize: 16 }}>Nossa sugestão</h2>

							<Plano
								plano={planoSugerido}
								botaoTexto="Contratar"
								botaoAction={() => {
									setPlanoContratacao(planoSugerido)
								}}
							/>
						</div>
					</div>
				</Card>
			</div>

			<Modal
				isOpen={!!planoContratacao}
				handleClose={() => {
					setPlanoContratacao(null)
				}}
				title="Confirmação"
			>
				<ModalPaymentContainer>
					{planoContratacao && (
						<div className="mx-2 flex flex-col">
							<p dangerouslySetInnerHTML={{
								__html: `Você está contratando o plano <span class="font-bold">${planoContratacao.descricao} ${planoContratacao.periodo === 'mensal' ? 'mensal' : 'anual'}</span> no valor de <span class="font-bold">${masks.maskApply.currency(planoContratacao.valor / 100)}/${planoContratacao.periodo === 'mensal' ? 'mês' : 'ano'}</span>.`
							}} />

							{/* <p
								className="mt-4"
								dangerouslySetInnerHTML={{
									__html: `Realizando o upgrade de plano agora, você pagará somente a diferença de <span class="font-bold">${masks.maskApply.currency(diferencaValorPlanos / 100)}</span>.`
								}}
							/> */}

							{/* {mudancaDePeriodo ? (
								<p className="mt-4" dangerouslySetInnerHTML={{
									__html: `A partir da sua próxima fatura, no dia <span class="font-bold">${format(addYears(new Date(), 1), 'dd/MM/yyyy')}</span>, o valor cobrado será de <span class="font-bold">${masks.maskApply.currency(planoContratacao.valor / 100)}/${planoContratacao.periodo === 'mensal' ? 'mês' : 'ano'}</span>.`
								}} />
							) : (
								<p className="mt-4" dangerouslySetInnerHTML={{
									__html: `A partir da sua próxima fatura, será cobrado o valor de <span class="font-bold">${masks.maskApply.currency(planoContratacao.valor / 100)}/${planoContratacao.periodo === 'mensal' ? 'mês' : 'ano'}</span>.`
								}} />
							)} */}

							<div id="cardPaymentBrick_container" className="animated fadeIn delay-2s my-8 self-center px-1 rounded-md border border-slate-200" />
						</div>
					)}
				</ModalPaymentContainer>
			</Modal>
		</>
	)
}

function Plano({
	plano,
	botaoTexto,
	botaoAction
}) {
	let percentualDesconto

	if (plano.periodo === 'anual') {
		const valorAnual = plano.valor
		percentualDesconto = plano.valor_sem_desconto ? 100 - Math.round((valorAnual * 100) / plano.valor_sem_desconto) : null
	} else { // mensal
		const valorAnual = plano.valor
		percentualDesconto = plano.valor_sem_desconto ? 100 - Math.round((valorAnual * 100) / plano.valor_sem_desconto) : null
	}

	return (
		<div className={`
			border rounded-xl p-8 flex flex-col h-fit border-gray-300
			transition-all duration-300 shadow-sm bg-white
		`}>
			<div className="flex flex-col">
				<h3 className="text-2xl font-bold text-gray-900 mb-2">{plano.descricao}</h3>

				<div className="flex flex-col">
					{plano.valor_sem_desconto && (
						<span className="line-through">
							{masks.maskApply.currency(plano.valor_sem_desconto / 100)}
						</span>
					)}

					<div className="flex justify-between gap-4">
						<div className="mb-4 text-slate-800">
							<span className="text-3xl font-bold">{masks.maskApply.currency(plano.valor / 100)}</span>
							{plano.valor !== "Personalizado" && <span className="text-gray-600">{plano.periodo === 'mensal' ? '/mês' : '/ano'}</span>}
						</div>

						{percentualDesconto && (
							<span className="bg-lime-300 rounded-md p-1 h-fit" style={{ fontSize: 13 }}>
								{`${percentualDesconto}% OFF`}
							</span>
						)}
					</div>
				</div>

				<p className="text-gray-700 mb-6">{plano.detalhes}</p>

				<ul className="space-y-3 mb-8">
					{plano.recursos.filter(recurso => recurso.publico).map((recurso, index) => (
						<li key={index} className="flex items-start">
							<Check size={20} className="text-emerald-500 mr-2 flex-shrink-0 mt-1" />
							<span className="text-gray-700" dangerouslySetInnerHTML={{
								__html: recurso.descricao
							}} />
						</li>
					))}
				</ul>

				{plano.detalhe_extra && <p className="text-gray-400 mb-6 text-xs mx-6">* {plano.detalhe_extra}</p>}

				{botaoTexto && (
					<span onClick={() => botaoAction(plano)} className={`
						w-full rounded-md px-4 py-3 text-center font-semibold cursor-pointer
						border border-gray-300 bg-emerald-600 hover:bg-emerald-500 text-white transition
					`}>
						{botaoTexto}
					</span>
				)}
			</div>
		</div>
	)
}